import React from "react";
import {ExperienceComp, SectionExp, DetailsSection, SectionTitle, DateInfo, TitleInfo, TextInfo} from "./ExperienceStyle";
import {TextDetail, TitleSection} from "../../course_details/components/Styles";
import {TypeTitle} from "../../../styles/Products";
import {ButtonLink} from "../../../styles/Button";
import {isMobile} from "../../../constants/Helpers";

export default function ExperienceComponent({data, contact}) {
   return (
      <ExperienceComp id={data.idCourse}>
         <SectionExp
            className="img"
            style={{
               backgroundImage: `url(http://domecqapi.trebolbit.com/${isMobile ? data.pathImageMobile : data.pathImageDesktop})`,
            }}
            // style={{backgroundImage: `url(${require("../../../assets/image/views/emblem/img_01_desk.png")})`}}
         >
            <SectionTitle>
               <img src={require("../../../assets/icons/diamon_circle.png")} alt="domecq" className="iconBox" />
               <TypeTitle>Programa emblem domecq</TypeTitle>
               <TitleSection>{data.courseName}</TitleSection>
            </SectionTitle>
         </SectionExp>
         <SectionExp>
            <DetailsSection>
               <DateInfo>
                  <div className="section">
                     <div>
                        <img src={require("../../../assets/icons/clock.png")} className="iconInfoDate" alt="icon" />
                     </div>
                     <div>
                        <TitleInfo>Duración</TitleInfo>
                        <TextInfo>{data.endDate}</TextInfo>
                     </div>
                  </div>
                  <div className="line" />
                  <div className="section">
                     <div>
                        <img src={require("../../../assets/icons/calendar.png")} className="iconInfoDate" alt="icon" />
                     </div>
                     <div>
                        <TitleInfo>Fecha</TitleInfo>
                        <TextInfo>{data.startDate}</TextInfo>
                     </div>
                  </div>
               </DateInfo>
               <TextDetail>{data.shortDescription}</TextDetail>
               <ButtonLink as="button" onClick={contact}>
                  Me interesa
               </ButtonLink>
            </DetailsSection>
         </SectionExp>
      </ExperienceComp>
   );
}
